import React from 'react';
import classNames from 'classnames';

const EventNoEmailFound = () => {
  return (
    <div
      className={classNames({
        container: true,
        'w-full': true,
        'max-w-xs': true,
        'mx-auto': true,
        'bg-red-gradient': true,
      })}
    >
      <div className="successSubmit px-8 pt-6 pb-8 mb-4 mt-4">
        <br />
        <h1 className="rejectionTitle text-center mt-4" style={{ color: '#fff' }}>
          {'Failed!'}
        </h1>
        <br />
        <p className="text-center text-white successText" style={{ fontSize: '14px' }}>
          Cannot able to find guest with email you provided please make sure you are using correct E-mail.
        </p>
      </div>
    </div>
  );
};
export default EventNoEmailFound;
